
module part {
  'use strict';


  export class PartCtrlSettings {
    constructor(
      public showList : boolean
      ) { }
  }
}